// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WifiBoxAddForm_wrapper__1xFfO"};